import { useSearchParams } from 'react-router';
import { Wordmark } from '../../layout/AppShell';
import { usePageTitle } from '../../ui/misc';

const REASONS: Record<string, { title: string; body: string }> = {
  no_access: {
    title: 'No access to Lixionary Jira',
    body: 'You signed in successfully, but your Lixionary account has no Jira role. Ask a Jira admin to invite you, then sign in again.',
  },
  inactive: {
    title: 'Account inactive',
    body: 'Your account has been deactivated. Contact an admin if you need access again.',
  },
  no_projects: {
    title: 'No project access',
    body: 'Your account is active but you are not a member of any project. Ask an admin to add you.',
  },
};

/** IDN-02–04: explains missing admission without revealing private records. */
export function AccessUnavailablePage() {
  usePageTitle('Access unavailable');
  const [params] = useSearchParams();
  const reason = REASONS[params.get('reason') ?? ''] ?? REASONS.no_access!;
  return (
    <div className="auth-layout">
      <div className="auth-card">
        <Wordmark size={28} />
        <div className="stack sm">
          <h1 className="page-title">Access unavailable</h1>
          <p className="strong">{reason.title}</p>
          <p className="muted">{reason.body}</p>
        </div>
        <a className="btn btn-secondary block" href="/api/v1/auth/login?prompt=login">
          Sign in with a different account
        </a>
      </div>
    </div>
  );
}
